module.exports = __webpack_public_path__ + "img/9788954435949.e27f9cd6.jpg";